import _ from "lodash";
import React from "react";
import classes from "./TopHeader.scss";
import ProfileCascade from "UIComponents/ProfileCascade";
import { useI18n } from "Hooks";
import {
  getFormattedUserName,
  getUserIdentifierName,
} from "Utils/GetFormattedUserName";

const TopHeader = React.memo(props => {
  const {
    userDetails,
    showRemarkOption,
    renderViewPinnedRemark,
    viewPinRemarkEnable,
    pinMessages,
  } = props;
  const { profileImage, children, status, isArchived } = userDetails || {};
  const getChildrenName = children => {
    return _.join(
      _.map(children, child => {
        const childName = getFormattedUserName({
          user: child,
        });
        return _.replace(childName, /,/g, "");
      }),
      ", "
    );
  };

  const { t } = useI18n(["common"]);

  return (
    <div className={classes.container}>
      <div className={classes.profileItem}>
        <ProfileCascade
          items={[
            {
              imageUrl: profileImage,
              value: getUserIdentifierName({ user: userDetails }),
            },
          ]}
          customStyle={{ backgroundColor: "grey" }}
          isArchived={isArchived}
        />
        <div className={classes.textContainer}>
          <div className={classes.labelText}>
            {getFormattedUserName({ user: userDetails })}
          </div>

          {/* Family communication */}
          {children && (
            <div className={classes.subText}>{getChildrenName(children)}</div>
          )}

          {/* Teacher Classroom View */}
          <div className={classes.statusWrapper}>
            {isArchived && (
              <div className={classes.archived}>{t("common:archived")}</div>
            )}
            {isArchived && status && (
              <span className={classes.splitter}>|</span>
            )}
            {status && <div className={classes.subText}>{status}</div>}
          </div>
        </div>
      </div>
      <div className={classes.viewPinnedRemark}>
        {showRemarkOption &&
          viewPinRemarkEnable &&
          renderViewPinnedRemark({ pinMessages })}
      </div>
    </div>
  );
});

TopHeader.displayName = "TopHeader";

export default TopHeader;
